import axiosInstance from "auth/FetchInterceptor";
import {
  PRICELIST_GET_ALL,
  PRICELIST_CREATE,
  PRICELIST_UPDATE,
  PRICELIST_CHANGE_STATUS,
  PRICELIST_DELETE,
  PRICELIST_APPLY_STORES,
  PRICELIST_STORE,
  PRICELIST_PRODUCTS,
  PRICELIST_ITEMS,
  PRICELIST_RESET_ITEMS,
  PRICELIST_BULK_DISCOUNT,
  PRICELIST_BULK_STATUS,
  PRICELIST_HISTORY,
  PRICELIST_STORES,
  PRICELIST_GET_STORE_PRICELIST,
  PRICELIST_PRODUCT_DETAIL,
} from "constants/ApiConstant";
const PriceListService = {};

PriceListService.getAllPriceList = function () {
  return axiosInstance.get(PRICELIST_GET_ALL, null);
};

PriceListService.createPriceList = function (data) {
  return axiosInstance.post(PRICELIST_CREATE, data);
};

PriceListService.updatePriceList = function (data) {
  return axiosInstance.put(PRICELIST_UPDATE, data);
};

PriceListService.changeStatusPriceList = function (data) {
  return axiosInstance.put(PRICELIST_CHANGE_STATUS, data);
};

PriceListService.deletePriceList = function (id) {
  return axiosInstance.delete(`${PRICELIST_DELETE}/${id}`, null);
};

PriceListService.getStoreListPriceList = function () {
  return axiosInstance.get(PRICELIST_STORES, null);
};

PriceListService.getStorePriceList = function (storeId) {
  return axiosInstance.get(`${PRICELIST_GET_STORE_PRICELIST}/${storeId}`, null);
};

PriceListService.applyStoresPriceList = function (data) {
  return axiosInstance.post(PRICELIST_APPLY_STORES, data);
};

PriceListService.applyStorePriceList = function (data) {
  return axiosInstance.put(PRICELIST_STORE, data);
};

PriceListService.getProductsByPriceList = function (data) {
  return axiosInstance.post(PRICELIST_PRODUCTS, data);
};

PriceListService.getProductDetailPriceList = function (data) {
  return axiosInstance.post(PRICELIST_PRODUCT_DETAIL, data);
};
PriceListService.updateItemsPriceList = function (data) {
  return axiosInstance.put(PRICELIST_ITEMS, data);
};

PriceListService.resetItemsPriceList = function (data) {
  return axiosInstance.post(PRICELIST_RESET_ITEMS, data);
};

PriceListService.bulkDiscountPriceList = function (data) {
  return axiosInstance.put(PRICELIST_BULK_DISCOUNT, data);
};

PriceListService.bulkStatusPriceList = function (data) {
  return axiosInstance.put(PRICELIST_BULK_STATUS, data);
};

PriceListService.getHistoryPriceList = function (data) {
  return axiosInstance.post(PRICELIST_HISTORY, data);
};

export default PriceListService;
